export default {
  "content": "<path d=\"M13.905 0H2.095c-.59 0-1.08.48-1.08 1.08v13.84c0 .6.49 1.08 1.08 1.08h11.81c.59 0 1.08-.48 1.08-1.08V1.08c0-.6-.49-1.08-1.08-1.08zm-2.42 12h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h7c.27 0 .5.22.5.5s-.23.5-.5.5zm0-3.5h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h7c.27 0 .5.22.5.5s-.23.5-.5.5zm0-3.5h-7c-.28 0-.5-.22-.5-.5s.22-.5.5-.5h7c.27 0 .5.22.5.5s-.23.5-.5.5z\"/>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "currentColor",
    "viewBox": "0 0 16 16"
  }
};